export const DOCUMENT_TYPE_CAB_SHOE_TRAY_PRODDUCT = 'commerce.cabShoeTrayProduct';
export const DOCUMENT_TYPE_CAB_SHOE_TRAY_STANDARD_SETTINGS = 'commerce.cabShoeTrayStandardSettings';

export const OBJECT_TYPE_CAB_SHOE_TRAY_PRODUCT_IMAGE_SETTINGS =
	'commerce.cabShoeTrayProductImageSettings';
